import KeywordsImprovement from "./KeywordsImprovement/KeywordsImprovement";
import LandingPageExperienceGetData from "./LandingPageExperienceGetData";
import TopKeywordsCard from "./TopKeywords/TopKeywordsCard";
import WeightedByCost from "./WeightedByCost";
import "./LandingPageExperience.css";
import { useSelector } from "react-redux";
//import SimpleBackdrop from "../../../BackDrop/BackDrop";
import { useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import LPSkeleton from "./LPSkeleton";
import FloatingActionItems from "../../../../pages/FloatingItems/FloatingActionItems";

const LandingPageExperience = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { lpLoader } = useSelector((state: any) => state.landingPageExperience);
  const selectedSite = searchParams.get("selectedSite") as any;
  const isClickedTrue = searchParams.get("is_clicked") === "true";
  const keyword_internal_id = searchParams.get("keyword_internal_id");
  const start_date = searchParams.get("start_date");
  const end_date = searchParams.get("end_date");
  //unset url params when back
  useEffect(() => {
    const updatedParams = new URLSearchParams(searchParams);
    if (keyword_internal_id) {
      updatedParams.delete("keyword_internal_id");
    }
    if (start_date) {
      updatedParams.delete("start_date");
    }
    if (end_date) {
      updatedParams.delete("end_date");
    }
    setSearchParams(updatedParams, { replace: true });
    // eslint-disable-next-line
  }, [keyword_internal_id, start_date, end_date]);

  return (
    <>
      <LandingPageExperienceGetData />
      {lpLoader ? (
        <>
          <LPSkeleton />
        </>
      ) : (
        <>
          {isClickedTrue && (
            <>
              <WeightedByCost />
              <KeywordsImprovement />
              <TopKeywordsCard />
              <div data-tracker="443">
                <FloatingActionItems
                  selectedSiteFloatingAction={selectedSite}
                  selectedDimensionsFloatingAction=""
                  trackIdFloatingAction="444"
                />
              </div>
            </>
          )}
        </>
      )}
    </>
  );
};

export default LandingPageExperience;
